import { render, staticRenderFns } from "./CustomerGroupListView.vue?vue&type=template&id=5ccedd09&scoped=true"
import script from "./CustomerGroupListView.vue?vue&type=script&lang=js"
export * from "./CustomerGroupListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccedd09",
  null
  
)

export default component.exports